module.exports = __webpack_public_path__ + "img/patrulla_estatal_up_selected.d0824f29.svg";